import { casOpsApi, QueryTag } from '../api';
import { FeatureCollection, LineString } from 'geojson';
import { CustomTimeRangeParams, getUrlParams } from './helpers';

interface AreaModel<T extends number | null | undefined = number | null | undefined> {
  sLat: T; // Start latitude (North)
  sLon: T; // Start longitude (West)
  eLat: T; // End latitude (South)
  eLon: T; // End longitude (East)
}

interface AssetTrackModel {
  id: number; // Asset Id
  line: FeatureCollection<LineString, null>; // LineStrings with no properties.
}

export interface AssetTracksResponse extends AreaModel<number> {
  tracks: AssetTrackModel[];
}

interface AssetTracksParams extends CustomTimeRangeParams {
  assetId: number;
}

interface AssetTracksQueryModel {
  trackId: string;
  query: AssetTracksParams;
}

export const assetTracksApi = casOpsApi.injectEndpoints({
  endpoints: build => ({
    getAssetTracks: build.query<AssetTracksResponse, AssetTracksQueryModel>({
      query: ({ query: { timeRangeStart, timeRangeEnd, assetId } }) => ({
        url: 'api/assettracks',
        params: getUrlParams({
          timeRangeStart,
          timeRangeEnd,
          assetIds: assetId.toString(),
        }),
      }),
      providesTags: (result, error, { trackId }) => {
        if (result) {
          return [{ type: QueryTag.AssetTrack, id: trackId }];
        } else {
          return [];
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetAssetTracksQuery } = assetTracksApi;
